import { combineReducers, createStore, applyMiddleware, Action, Store, CombinedState, AnyAction } from "redux";
import { ThunkAction } from 'redux-thunk';
import ReduxThunk from 'redux-thunk';

import { uiReducer } from './ui/reducers';
import { paramentorReducer } from './paramentor/reducers';
import { authReducer } from '../../packages/identity/dist/redux/reducers';

import { paramentorReset } from './paramentor/actions';
import { authResetSubscribers } from '../../packages/identity/dist/redux/actions';

const rootReducer = combineReducers({
    ui: uiReducer,
    paramentor: paramentorReducer,
    auth: authReducer,
});

export const store:Store = createStore(rootReducer, applyMiddleware(ReduxThunk));

store.dispatch(<any>authResetSubscribers([paramentorReset]));

export type AppState = ReturnType<typeof rootReducer>

export type AppThunkAction = ThunkAction<void, AppState, unknown, Action<string>>;
